import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
import { cn } from '../../src/lib/utils';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  description?: React.ReactNode;
  align?: 'left' | 'center';
  size?: 'md' | 'lg';
  headingId?: string;
  className?: string;
  /** Use `dark` inside night sections. */
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  size = 'md',
  headingId,
  className,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <Reveal className={cn('flex flex-col gap-4', align === 'center' ? 'mx-auto items-center text-center' : 'items-start', className)} data-id="element-1291" data-mp="d8bvu88arx20">
      {eyebrow ? <Eyebrow tone={tone} data-id="element-1292" data-mp="47x8l3brw7vv">{eyebrow}</Eyebrow> : null}
      <h2 id={headingId} className={cn('sf-display max-w-4xl text-balance leading-[1.04]', dark ? 'on-dark text-night-text' : 'text-text-primary', size === 'lg' ? 'text-[34px] sm:text-[52px] lg:text-[64px]' : 'text-[30px] sm:text-[42px] lg:text-[50px]')} data-id="element-1293" data-mp="47dqnmm4hjhu">
        {title}
      </h2>
      {description ? <p className={cn('max-w-2xl text-[15px] leading-relaxed sm:text-base', dark ? 'text-night-muted' : 'text-text-secondary')} data-id="element-1294" data-mp="151fp9bgkh0on">
          {description}
        </p> : null}
    </Reveal>;
}